import React, { useState, useEffect, useMemo } from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Divider,
  Chip,
  Paper,
  Avatar,
  Alert,
  LinearProgress,
  Checkbox,
  IconButton,
  Tooltip,
  Button,
  Collapse,
  Stack,
  TextField,
  CircularProgress,
  Modal,
  InputLabel,
} from "@mui/material";
import AsyncSelect from "react-select/async";

import axios from "axios";
import {
  Person as PersonIcon,
  LocalHospital as HospitalIcon,
  CreditCard as CreditCardIcon,
  Receipt as ReceiptIcon,
  CheckCircle as CheckCircleIcon,
  CalendarToday as CalendarIcon,
  FileCopy as FileCopyIcon,
  Settings as SettingsIcon,
  Visibility as VisibilityIcon,
  AccessTime as TimeIcon,
  Add as AddIcon,
  Comment,
} from "@mui/icons-material";
import Swal from "sweetalert2";
import ReactSelect from "react-select";
import moment from "moment";
import Headroom from "react-headroom";
import DialogTitle from "@mui/material/DialogTitle";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ClaimRegistration from "../ClaimRegistration";
import Prior_auth from "../Prior_auth";
import AuthorizationRegistration from "../AuthorizationRegistration";
const PatientSummary = ({ patientId, PatientINFO, ResetTab, setResetTab }) => {
  // Card visibility state
  const [cardVisibility, setCardVisibility] = useState({
    contact: true,
    medical: true,
    insurance: true,
    provider: true,
    ReferringPhysician: true,
    financial: true,
    authorizations: true,
    appointments: true,
    documents: true,
    Comments: true,
    // alerts: true,
  });

  // Simple state for all data
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Individual data states
  const [insuranceList, setInsuranceList] = useState([]);
  const [priorAuth, setPriorAuth] = useState({});
  const [provider, setProvider] = useState({});
  const [referringProvider, setReferringProvider] = useState([]);
  const [claimsList, setClaimsList] = useState([]);
  const [AuthList, setAuthList] = useState([]);
  const [appointmentsList, setAppointmentsList] = useState([]);
  const [payments, setPayments] = useState({});
  // Sort appointments by nearest date + earliest start time
  const sortedAppointments = React.useMemo(() => {
    return [...(appointmentsList || [])]
      .filter((a) => a.startTime) // safety check
      .sort((a, b) => {
        return new Date(a.startTime) - new Date(b.startTime);
      });
  }, [appointmentsList]);
  // UI states
  const [showOptions, setShowOptions] = useState(false);
  const [activeCards, setActiveCards] = useState(7);

  // Load saved preferences
  useEffect(() => {
    const savedVisibility = localStorage.getItem("cardVisibility");
    if (savedVisibility) {
      try {
        const parsedVisibility = JSON.parse(savedVisibility);
        setCardVisibility(parsedVisibility);

        // Count active cards
        const activeCount = Object.values(parsedVisibility).filter(
          (v) => v,
        ).length;
        setActiveCards(activeCount);
      } catch (err) {
        console.log("Error loading saved preferences");
      }
    }
  }, []);
  const style = {
    position: "absolute",
    top: "54%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: "0px 0px 24px rgba(0, 0, 0, 0.5)",
    padding: "15px",
    borderRadius: "8px",
    maxHeight: "89vh",
    // overflow: 'auto',
  };
  // Fetch data from API
  const [isEditing, setIsEditing] = useState(false);
  const [commentText, setCommentText] = useState("");
  const handleEdit = () => setIsEditing(true);
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const handleSaveComments = () => {
    const postData = {
      id: PatientINFO?.id,
      comments: commentText,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Patients/updatePatientComments`,
        postData,
        {
          headers: { Authorization: auth },
        },
      )
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Notes saved successfully",
          timer: 2000,
          showConfirmButton: false,
          willClose: () => null,
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              swalPopup.style.zIndex = 5000;
              const swalContent = swalPopup.querySelector(".swal2-popup");
              if (swalContent) swalContent.style.zIndex = 5001;
            }
          },
        });
        setIsEditing(false); // Exit editing mode after save
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Error: ${error.message}`,
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              swalPopup.style.zIndex = 5000;
              const swalContent = swalPopup.querySelector(".swal2-popup");
              if (swalContent) swalContent.style.zIndex = 5001;
            }
          },
        });
      });
  };
  const [refresh, setRefresh] = useState(false);
  const HandleRefresh = () => {
    setRefresh((prev) => !prev); // toggle = re-fetch
  };

  const fetchPatientData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("Token");
      const auth = `Bearer ${token}`;

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Patients/GetSummary?patientId=${patientId}`,
        {
          headers: { Authorization: auth },
        },
      );

      if (response) {
        // Set each data piece individually
        setInsuranceList(response.insurance || []);
        setPriorAuth(response.priorAuth || {});
        setProvider(response.provider || {});
        setReferringProvider(response.referringProvider || []);
        setClaimsList(response.claims || []);
        setAuthList(response.authorizationSummary || []);
        setAppointmentsList(response.appointments || []);
        setPayments(response.payments || {});
        setCommentText(response.patientsComments.comments);
      }
    } catch (err) {
      setError(err.message || "Failed to fetch data");
      console.error("Error fetching patient data:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (patientId) {
      fetchPatientData();
    }
  }, [patientId, refresh]);

  // Update active cards count
  useEffect(() => {
    const count = Object.values(cardVisibility).filter((v) => v).length;
    setActiveCards(count);
  }, [cardVisibility]);

  // Toggle card visibility
  const handleCardToggle = (cardKey) => {
    setCardVisibility((prev) => ({
      ...prev,
      [cardKey]: !prev[cardKey],
    }));
  };

  // Control functions
  const handleShowAll = () => {
    const allVisible = Object.keys(cardVisibility).reduce((acc, key) => {
      acc[key] = true;
      return acc;
    }, {});
    setCardVisibility(allVisible);
  };

  const handleShowNone = () => {
    const noneVisible = Object.keys(cardVisibility).reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {});
    setCardVisibility(noneVisible);
  };
  const [openClaimModal, setOpenClaimModal] = useState(false);
  const [SelectedClaimId, setSelectedClaimId] = useState(0);
  const [OpenpriorAuth, setOpenpriorAuth] = React.useState(false);
  const [selectedAuth, setselectedAuth] = useState(null);
  const handleCloseVOb = () => {
    setOpenpriorAuth(false);
    setselectedAuth(null);
  };
  const handleCloseClaim = () => {
    setOpenClaimModal(false);
    setSelectedClaimId(0);
  };

  const patientFullName = PatientINFO
    ? `${PatientINFO.lastName}, ${PatientINFO.firstName}`
    : "";

  const isAuthorization = selectedAuth?.source === "Authoorization";
  const [appid, setappid] = useState(0);

  const [NewAppointment, setNewAppointment] = useState(false);
  const HanldeOpenNewAppointment = () => {
    setNewAppointment(true);
  };

  const HandleCloseNewAppointment = () => {
    setNewAppointment(false);
    setProviderId(null);
    setAppointmentDate("");
    setappid(0)
    setSTime("");
    setETime("");
    setDuration("");
    setAppointmentReason("");
  };
  const [NewVOB, setNewVOB] = useState(false);
  const HanldeOpenNewVOB = () => {
    setNewVOB(true);
  };
  const HandleCloseNewVOB = () => {
    setNewVOB(false);
  };
  const [NewInsurance, setNewInsurance] = useState(false);
  const handleOpenNewInsurance = () => setNewInsurance(true);
  const HandleCloseNewInsurance = () => {
    setNewInsurance(false);
  };
  const [priInsuranceId, setPriInsuranceId] = useState(null);
  const [secInsuranceId, setSecInsuranceId] = useState(null);

  const [PriPayerId, setPriPayerId] = useState("");
  const [SecPayerId, setSecPayerId] = useState("");
  const [priMemberId, setPriMemberId] = useState("");
  const [secMemberId, setSecMemberId] = useState("");
  const [patientInsuranceName, setPatientInsuranceName] = useState("");
  const [SecondarInsuranceName, setSecondarInsuranceName] = useState("");
  const loadInsuranceOptions = async (inputValue) => {
    if (!inputValue) return [];

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Insurances/getInsuranceByName?Name=${inputValue}`,
        {
          headers: { Authorization: auth },
        },
      );

      const data = response || [];

      return data.map((field) => ({
        label: `${field.name} (Payer ID: ${field.payerid})`,
        value: field.id,
        payerId: field.payerid,
      }));
    } catch (error) {
      console.error(error);
      return [];
    }
  };
  const handleSubmitInsurance = async () => {
    try {
      const primaryInsurance = {
        patientId: patientId,
        type: "primary",
        planName: patientInsuranceName,
        payerId: PriPayerId,
        relation: "Self",
        memberId: priMemberId, // ✅ added
        insuranceId: priInsuranceId,
      };

      let secondaryInsurance = null;

      if (secInsuranceId) {
        secondaryInsurance = {
          patientId: patientId,
          type: "secondary",
          planName: SecondarInsuranceName,
          payerId: SecPayerId,
          relation: "Self",
          memberId: secMemberId, // ✅ added
          insuranceId: secInsuranceId,
        };
      }

      const insurances = [primaryInsurance];
      if (secondaryInsurance) insurances.push(secondaryInsurance);

      await axios.post(
        `${process.env.REACT_APP_API_URL}/Patients/UpdatePatientInsurance`,
        insurances,
        {
          headers: { Authorization: auth },
        },
      );

      // ✅ SUCCESS ALERT
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Insurance updated successfully!",
        timer: 2000, // auto close
        showConfirmButton: false,
      });

      HandleCloseNewInsurance();
    } catch (error) {
      console.error(error);

      // ❌ ERROR ALERT
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update insurance. Please try again.",
        confirmButtonColor: "#d33",
      });
    }
  };
  const [columnID, setColumnID] = useState(0);
  const setAuthId = () => {
    setColumnID(0);
  };
  const [providerList, setProviderList] = useState([]);
  const [providerId, setProviderId] = useState(null);
  const [providerError, setProviderError] = useState(false);
  const [appointmentDate, setAppointmentDate] = useState("");
  const [sTime, setSTime] = useState("");
  const [eTime, setETime] = useState("");
  const [duration, setDuration] = useState(0);
  const [appointmentReason, setAppointmentReason] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [providerName, setProviderName] = useState("");
  const calculateDuration = (startTime, endTime) => {
    if (!startTime || !endTime) {
      setDuration(0);
      return;
    }
    const today = moment().format("YYYY-MM-DD");
    let startTimeMoment = moment(`${today} ${startTime}`, "YYYY-MM-DD hh:mm A");
    let endTimeMoment = moment(`${today} ${endTime}`, "YYYY-MM-DD hh:mm A");
    if (!endTimeMoment.isAfter(startTimeMoment)) {
      endTimeMoment.add(1, "day");
    }

    const durationInMinutes = endTimeMoment.diff(startTimeMoment, "minutes");
    setDuration(durationInMinutes); // Store as number
  };

  const handleOpenAppointment = (id) => {
    if (id) {
      setNewAppointment(true);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Appointment/getAppointmentById?id=${id}`,
          { headers: { Authorization: auth } },
        )
        .then((response) => {
          var dateYMD = moment(response.appointmentDate).format("YYYY-MM-DD");
          setAppointmentDate(dateYMD);
          var dateYMD = moment(response.startTime).format("HH:mm:ss");
          setSTime(dateYMD);
          var dateYMD = moment(response.endTime).format("HH:mm:ss");
          setETime(dateYMD);
          setProviderId(response.providerId);
          setAppointmentReason(response.appointmentReason);
          setappid(response.id);
        })
        .catch((error) => {});
    }
  };
  const handleSendReminder = () => {
    setSubmitting(true);
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Appointment/SendAppointmentReminder`,
        appid,
        { headers: { Authorization: auth } },
      )
      .then((response) => {
        setSubmitting(false);
        Swal.fire({
          icon: "success",
          title: "Reminder Sent",
          html: response?.message || "Reminder sent successfully.",
          willOpen: () => {
            const swalContainer = document.querySelector(".swal2-container");
            if (swalContainer) {
              swalContainer.style.zIndex = 5000; // container
              const swalPopup = swalContainer.querySelector(".swal2-popup");
              if (swalPopup) swalPopup.style.zIndex = 5001; // actual popup
            }
          },
          showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true,
        });
        HandleCloseNewAppointment()
      })
      .catch((error) => {
        setSubmitting(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          html: error.message || "Something went wrong.",
          willOpen: () => {
            const swalContainer = document.querySelector(".swal2-container");
            if (swalContainer) {
              swalContainer.style.zIndex = 5000;
              const swalPopup = swalContainer.querySelector(".swal2-popup");
              if (swalPopup) swalPopup.style.zIndex = 5001;
            }
          },
          confirmButtonText: "OK",
        });
      });
  };
  const handleSubmitAPp = () => {
    setSubmitting(true);

    if (!providerId) {
      setProviderError(true);
      setSubmitting(false);

      Swal.fire({
        icon: "warning",
        title: "Provider Required",
        showConfirmButton: true,
        willClose: () => null,
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) {
            swalPopup.style.zIndex = 5000;
            const swalContent = swalPopup.querySelector(".swal2-popup");
            if (swalContent) swalContent.style.zIndex = 5001;
          }
        },
      });

      return;
    }
    if (!appointmentDate) {
      setSubmitting(false);

      Swal.fire({
        icon: "warning",
        title: "Appointment Date Required",
        text: "Please select an appointment date.",
        showConfirmButton: true,
        willClose: () => null,
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) {
            swalPopup.style.zIndex = 5000;
            const swalContent = swalPopup.querySelector(".swal2-popup");
            if (swalContent) swalContent.style.zIndex = 5001;
          }
        },
      });

      return;
    }

    // (Optional) ✅ Past Date Validation
    const today = new Date().setHours(0, 0, 0, 0);
    const selectedDate = new Date(appointmentDate).setHours(0, 0, 0, 0);

    if (selectedDate < today) {
      setSubmitting(false);

      Swal.fire({
        icon: "warning",
        title: "Invalid Date",
        text: "Appointment date cannot be in the past.",
        showConfirmButton: true,
        willClose: () => null,
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) {
            swalPopup.style.zIndex = 5000;
            const swalContent = swalPopup.querySelector(".swal2-popup");
            if (swalContent) swalContent.style.zIndex = 5001;
          }
        },
      });

      return;
    }
    const postData = {
      providerId: Number(providerId),
      id:appid,
      appointmentDate,
      startTime: `${appointmentDate}T${sTime}`,
      endTime: `${appointmentDate}T${eTime}`,
      appointmentReason,
      duration,
      patientName: patientFullName,
      patientId,
      providerName,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Appointment/AddAppointment`,
        postData,
        { headers: { Authorization: auth } },
      )
      .then(() => {
        setSubmitting(false);
        fetchPatientData();
        Swal.fire({
          icon: "success",
          title: "Record saved successfully",
          timer: 2000,
          showConfirmButton: false,
          willClose: () => null,
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              swalPopup.style.zIndex = 5000;
              const swalContent = swalPopup.querySelector(".swal2-popup");
              if (swalContent) swalContent.style.zIndex = 5001;
            }
          },
        }).then(() => {
          HandleCloseNewAppointment();
        });
      })
      .catch((error) => {
        setSubmitting(false);

        Swal.fire({
          icon: "error",
          title: "Error saving record",
          text: error?.message || "Something went wrong",
          timer: 2500,
          showConfirmButton: false,
          willClose: () => null,
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              swalPopup.style.zIndex = 5000;
              const swalContent = swalPopup.querySelector(".swal2-popup");
              if (swalContent) swalContent.style.zIndex = 5001;
            }
          },
        });
      });
  };

  useEffect(() => {
    calculateDuration(sTime, eTime);
  }, [sTime, eTime]);
  const practiceId = localStorage.getItem("default_paractice");
  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/Providers/getProviders?practiceId=${practiceId}`,
        {
          headers: { Authorization: auth },
        },
      )
      .then((response) => {
        var prac = [];
        response.forEach((field) => {
          prac.push({
            label: `${field.firstName} ${field.lastName}`,
            value: field.id,
          });
        });
        setProviderList(prac);
      })
      .catch((error) => {});
  }, []);

  const savePreferences = () => {
    localStorage.setItem("cardVisibility", JSON.stringify(cardVisibility));
    Swal.fire({
      icon: "success",
      title: "Preferences Saved",
      text: "Your card visibility preferences have been saved successfully!",
      timer: 2000, // Auto close after 2 seconds
      showConfirmButton: false,
    });
    setShowOptions(!showOptions);
  };

  const primaryInsurance =
    insuranceList.find((ins) => ins.type === "primary") || insuranceList[0];
  const secondaryInsurance =
    insuranceList.find((ins) => ins.type === "secondary") || insuranceList[1];

  // Get procedure and diagnosis codes
  const procedureCodes = [
    priorAuth?.procedureCode1,
    priorAuth?.procedureCode2,
    priorAuth?.procedureCode3,
  ].filter((code) => code && code.trim() !== "");

  const diagnosisCodes = [
    priorAuth?.diagnosisCode1,
    priorAuth?.diagnosisCode2,
    priorAuth?.diagnosisCode3,
  ].filter((code) => code && code.trim() !== "");

  // Get next appointment
  const nextAppointment =
    appointmentsList.length > 0 ? appointmentsList[0] : null;

  // Get recent claims
  const recentClaims = claimsList.slice(0, 3).map((claim) => ({
    id: claim.id,
    name: `Claim ID #${claim.id}`,
    date: claim.createdDate
      ? new Date(claim.createdDate).toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        })
      : "N/A",
    amount: `$${claim.totalCharges || 0}`,
    statusColor: claim.statusColor,
  }));
  const recentAuths = AuthList.slice(0, 3).map((row) => ({
    name: `Auth ID #${row.authId}`,
    id: row.authId,
    source: row.source,
    date: row.priorAuthSubmitted
      ? new Date(row.priorAuthSubmitted).toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        })
      : "N/A",
    cptCode: row.cptCode,
    statusColor: row.statusColor,
  }));
  // Card configuration
  const cardConfig = {
    contact: { title: "Patient Info", icon: <PersonIcon />, size: 3 },
    medical: { title: "Medical Codes", icon: <HospitalIcon />, size: 3 },
    Comments: { title: "Patient's Comments", icon: <Comment />, size: 3 },
    insurance: { title: "Insurance", icon: <CreditCardIcon />, size: 3 },
    provider: { title: "Provider Info", icon: <HospitalIcon />, size: 3 },
    ReferringPhysician: {
      title: "Referring Physician Info",
      icon: <HospitalIcon />,
      size: 3,
    },
    authorizations: {
      title: "Auth/VOBs",
      icon: <CheckCircleIcon />,
      size: 3,
    },
    documents: { title: "Recent Claims", icon: <FileCopyIcon />, size: 3 },
    appointments: { title: "Appointments", icon: <CalendarIcon />, size: 3 },
    financial: { title: "Financial", icon: <ReceiptIcon />, size: 12 },
  };
  const alerts = [
    ...(nextAppointment
      ? [
          {
            type: "info",
            text: `Upcoming appointment: ${new Date(
              nextAppointment.appointmentDate,
            ).toLocaleDateString()}`,
          },
        ]
      : []),
  ];
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const formatTime = (timeString) => {
    if (!timeString) return "N/A";
    return new Date(timeString).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };
  // Render Card Components
  const ContactCard = () => (
    <Card
      sx={{
        height: "100%",
        borderRadius: 3,
        border: "1px solid #e0e0e0",
        boxShadow: 1,
      }}
    >
      <CardContent sx={{ p: 1 }}>
        {/* Header */}
        <Box display="flex" alignItems="center" mb={2}>
          <Box sx={{ bgcolor: "#e3f2fd", p: 1, borderRadius: 1, mr: 1.5 }}>
            <PersonIcon sx={{ color: "#1976d2", fontSize: 20 }} />
          </Box>
          <Typography variant="subtitle1" fontWeight="600">
            Patient Information
          </Typography>
        </Box>

        <Stack spacing={1}>
          {/* Patient Basic Info */}
          <Box>
            <Typography variant="body1" fontWeight={600}>
              {PatientINFO?.lastName}, {PatientINFO?.firstName}
            </Typography>

            <Box mt={0.5} display="flex" flexDirection="column" gap={0.3}>
              <Typography variant="body2" fontWeight="500">
                <b>Email:</b> {PatientINFO?.emailAddress || "-"}
              </Typography>

              <Typography variant="body2" fontWeight="500">
                <b>DOB:</b> {PatientINFO?.dob || "-"}
              </Typography>

              <Typography variant="body2" fontWeight="500">
                <b>Phone:</b> {PatientINFO?.cellPhone || "-"}
              </Typography>

              <Typography
                variant="body2"
                fontWeight="500"
                sx={{ maxWidth: 220 }}
                noWrap
                title={PatientINFO?.address || "-"}
              >
                <b>Address:</b> {PatientINFO?.address || "-"}
              </Typography>
            </Box>
          </Box>
        </Stack>
        <Divider />
        <Box sx={{ bgcolor: "#fafafa", mt: 1, p: 1 }}>
          <Typography
            variant="caption"
            fontStyle="italic"
            color="text.secondary"
            sx={{
              textAlign: "center",
              lineHeight: 1.1,
              letterSpacing: "0.01em",
            }}
          >
            Detailed patient information is available in the demographic section
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );

  const MedicalCard = () => (
    <Card
      sx={{
        height: "100%",
        borderRadius: 3,
        border: "1px solid #e0e0e0",
        boxShadow: 1,
      }}
    >
      <CardContent sx={{ p: 1 }}>
        {/* Header */}
        <Box display="flex" alignItems="center" mb={2}>
          <Box sx={{ bgcolor: "#ede7f6", p: 1, borderRadius: 1, mr: 1.5 }}>
            <HospitalIcon sx={{ color: "#5e35b1", fontSize: 20 }} />
          </Box>
          <Typography variant="subtitle1" fontWeight="600">
            Diagnosis/Procedure Codes
          </Typography>
        </Box>

        <Stack spacing={2}>
          {/* Diagnosis Codes */}
          {diagnosisCodes.length > 0 && (
            <Box>
              <Typography
                variant="subtitle2"
                color="primary"
                fontWeight={600}
                mb={1}
              >
                Diagnosis Codes
              </Typography>
              <Box display="flex" flexWrap="wrap" gap={0.5}>
                {diagnosisCodes.map((code, index) => (
                  <Chip
                    key={index}
                    label={code}
                    size="small"
                    sx={{
                      fontSize: "0.75rem",
                      height: 28,
                      borderRadius: 1.5,
                      bgcolor: "#e8eaf6",
                      color: "#3f51b5",
                      fontWeight: 500,
                    }}
                  />
                ))}
              </Box>
            </Box>
          )}

          {/* Procedure Codes */}
          <Divider />

          {procedureCodes.length > 0 && (
            <Box>
              <Typography
                variant="subtitle2"
                color="secondary"
                fontWeight={600}
                mb={1}
              >
                Procedure Codes
              </Typography>
              <Box display="flex" flexWrap="wrap" gap={0.5}>
                {procedureCodes.map((code, index) => (
                  <Chip
                    key={index}
                    label={code}
                    size="small"
                    sx={{
                      fontSize: "0.75rem",
                      height: 28,
                      borderRadius: 1.5,
                      bgcolor: "#f3e5f5",
                      color: "#7b1fa2",
                      fontWeight: 500,
                    }}
                  />
                ))}
              </Box>
            </Box>
          )}

          {/* No Codes */}
          {diagnosisCodes.length === 0 && procedureCodes.length === 0 && (
            <Typography variant="body2" color="textSecondary">
              No medical codes available
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );

  const InsuranceCard = ({ handleOpenNewInsurance }) => (
    <Card sx={{ height: "100%", borderRadius: 2, border: "1px solid #e0e0e0" }}>
      <CardContent sx={{ p: 1 }}>
        <Box display="flex" alignItems="center" mb={2}>
          <Box sx={{ bgcolor: "#e8f5e9", p: 1, borderRadius: 1, mr: 1.5 }}>
            <CreditCardIcon sx={{ color: "#2e7d32", fontSize: 20 }} />
          </Box>
          <Typography variant="subtitle1" fontWeight="600">
            Insurance
          </Typography>
          <Button
            size="small"
            startIcon={<AddIcon />}
            onClick={() => {
              console.log("CLICK WORKING");
              handleOpenNewInsurance();
            }}
            sx={{
              ml: "auto", // 🔥 this pushes button to right
              textTransform: "none",
              fontWeight: 600,
              borderRadius: 2,
              px: 2,
              bgcolor: "#689f38",
              boxShadow: "none",
              "&:hover": {
                bgcolor: "#689f38",
                boxShadow: "none",
              },
            }}
            variant="contained"
          >
            Add
          </Button>
        </Box>

        <Stack spacing={1}>
          {primaryInsurance && (
            <Box>
              <Typography
                variant="subtitle2"
                color="primary"
                fontWeight={600}
                // mb={1}
              >
                Primary Insurance
              </Typography>
              <Typography variant="body2" fontWeight="500">
                {primaryInsurance.planName || "N/A"}
              </Typography>
              <Box display="flex" justifyContent="space-between">
                <Box>
                  <Typography variant="caption" color="textSecondary">
                    Member ID
                  </Typography>
                  <Typography variant="body2">
                    {primaryInsurance.memberId || "N/A"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="textSecondary">
                    Payer ID
                  </Typography>
                  <Typography variant="body2">
                    {primaryInsurance.payerId || "N/A"}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}

          {secondaryInsurance && (
            <>
              <Divider />
              <Box>
                <Typography
                  variant="subtitle2"
                  color="secondary"
                  fontWeight={600}
                  mb={1}
                >
                  Secondary Insurance
                </Typography>
                <Typography variant="body2" fontWeight="500">
                  {secondaryInsurance.planName || "N/A"}
                </Typography>
                <Box display="flex" justifyContent="space-between">
                  <Box>
                    <Typography variant="caption" color="textSecondary">
                      Member ID
                    </Typography>
                    <Typography variant="body2">
                      {secondaryInsurance.memberId || "N/A"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="textSecondary">
                      Payer ID
                    </Typography>
                    <Typography variant="body2">
                      {secondaryInsurance.payerId || "N/A"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </>
          )}

          {!primaryInsurance && !secondaryInsurance && (
            <Typography variant="caption" color="textSecondary">
              No insurance information available
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );

  const ProviderCard = () => {
    const providerName =
      provider.firstName || provider.lastName
        ? `${provider.firstName || ""} ${provider.lastName || ""}`.trim()
        : "N/A";

    // const referringProviderName =
    //   referringProvider.firstName || referringProvider.lastName
    //     ? `${referringProvider.firstName || ""} ${
    //         referringProvider.lastName || ""
    //       }`.trim()
    //     : "N/A";

    return (
      <Card
        sx={{ height: "100%", borderRadius: 2, border: "1px solid #e0e0e0" }}
      >
        <CardContent sx={{ p: 1 }}>
          <Box display="flex" alignItems="center" mb={2}>
            <Box sx={{ bgcolor: "#fff3e0", p: 1, borderRadius: 1, mr: 1.5 }}>
              <HospitalIcon sx={{ color: "#f57c00", fontSize: 20 }} />
            </Box>
            <Typography variant="subtitle1" fontWeight="600">
              Provider Info
            </Typography>
          </Box>

          <Stack spacing={1}>
            <Box>
              <Typography
                variant="subtitle2"
                color="primary"
                fontWeight={600}
                mb={1}
              >
                Attending Provider
              </Typography>
              <Typography variant="body2" fontWeight="500">
                {providerName}
              </Typography>
              <Box display="flex" justifyContent="space-between">
                <Box>
                  <Typography variant="caption" color="textSecondary">
                    NPI
                  </Typography>
                  <Typography variant="body2">
                    {provider.nPI || "N/A"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="textSecondary">
                    Phone
                  </Typography>
                  <Typography variant="body2">
                    {provider.phoneNo || "N/A"}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/*{referringProviderName !== "N/A" && (
              <>
                <Divider />
                <Box>
                  <Typography
                    variant="subtitle2"
                    color="secondary"
                    fontWeight={600}
                    mb={1}
                  >
                    Referring Provider
                  </Typography>
                  <Typography variant="body2" fontWeight="500">
                    {referringProviderName}
                  </Typography>
                  <Box display="flex" justifyContent="space-between">
                    <Box>
                      <Typography variant="caption" color="textSecondary">
                        NPI
                      </Typography>
                      <Typography variant="body2">
                        {referringProvider.npi || "N/A"}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="caption" color="textSecondary">
                        Phone
                      </Typography>
                      <Typography variant="body2">
                        {referringProvider.phone || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </>
            )} */}
          </Stack>
        </CardContent>
      </Card>
    );
  };
  const primary = referringProvider[0];
  const secondary = referringProvider[1];
  const handleGoToPatientChart = () => {
    if (ResetTab == "1") {
      setResetTab("2");
    }
  };

  const FinancialCard = () => (
    <Card sx={{ borderRadius: 2, border: "1px solid #e0e0e0", boxShadow: 1 }}>
      <CardContent sx={{ p: 1 }}>
        <Grid container spacing={1} alignItems="center">
          {/* Total Paid */}
          <Grid item>
            <Box
              textAlign="center"
              sx={{
                bgcolor: "#e8f5e9",
                px: 3,
                py: 1,
                borderRadius: 2,
                minWidth: 100,
                boxShadow: 0.5,
              }}
            >
              <Typography
                variant="subtitle1"
                color="success.dark"
                fontWeight="600"
              >
                ${payments.totalPaid}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                Total Paid
              </Typography>
            </Box>
          </Grid>

          {/* Total Charges */}
          <Grid item>
            <Box
              textAlign="center"
              sx={{
                bgcolor: "#e0f7fa",
                px: 3,
                py: 1,
                borderRadius: 2,
                minWidth: 100,
                boxShadow: 0.5,
              }}
            >
              <Typography
                variant="subtitle1"
                color="info.dark"
                fontWeight="600"
              >
                ${payments.totalCharges}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                Total Charges
              </Typography>
            </Box>
          </Grid>

          {/* Patient Balance at the end */}
          <Grid item xs>
            <Box
              textAlign="right"
              sx={{
                bgcolor: "#ffebee",
                px: 3,
                py: 1,
                borderRadius: 2,
                minWidth: 120,
                boxShadow: 0.5,
              }}
            >
              <Typography variant="subtitle1" color="error" fontWeight="600">
                ${payments.totalBalance}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                Patient Balance
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  const getStatusChipStyle = (color) => ({
    bgcolor: color || "#9e9e9e",
    color: "#fff",
    height: 20,
    fontSize: "0.65rem",
    fontWeight: 600,
  });
  const getStatusLabel = (color) => {
    switch (color) {
      case "Red":
        return "New";
      case "Orange":
        return "Pending";
      case "Purple":
        return "Pending Further Review";
      case "Green":
        return "Approved";
      default:
        return "Status";
    }
  };
  const getClaimStatus = (statusColor) => {
    switch (statusColor) {
      case "red":
        return { label: "New", bg: "red" };
      case "brown":
        return { label: "Secondary Pending", bg: "brown" };
      case "orange":
        return { label: "Pending", bg: "#ff9800" };
      case "purple":
        return { label: "Pending further review", bg: "purple" };
      case "Blueviolet":
        return { label: "Secondary Pending further review", bg: "Blueviolet" };
      case "green":
        return { label: "Completed", bg: "green" };
      case "black":
        return { label: "Closed", bg: "black" };
      case "skyblue":
        return { label: "Partially Paid", bg: "skyblue" };
      case "blue":
        return { label: "Paid", bg: "blue" };
      default:
        return { label: "Unknown", bg: "#9e9e9e" };
    }
  };

  // Loading state
  if (loading) {
    return (
      <Container
        maxWidth="xl"
        sx={{
          py: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "60vh",
        }}
      >
        <Box textAlign="center">
          <CircularProgress />
          <Typography variant="h6" sx={{ mt: 2 }}>
            Loading patient summary...
          </Typography>
        </Box>
      </Container>
    );
  }

  // Error state
  if (error) {
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          Error loading patient data: {error}
        </Alert>
        <Button variant="contained" onClick={() => window.location.reload()}>
          Retry
        </Button>
      </Container>
    );
  }

  return (
    <React.Fragment>
      <Modal
        open={openClaimModal}
        onClose={handleCloseClaim}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 1,
          zIndex: 1802,
        }}
      >

        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 24,
            width: { xs: "95%", sm: "90%", md: "80%", lg: "70%" },
            maxHeight: "90vh",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Headroom>
            <Grid
              container
              alignItems="center"
              sx={{
                backgroundColor: "#356F60",
                position: "sticky",
                top: 0,
                zIndex: 10,
                px: { xs: 1.5, sm: 2 },
                py: { xs: 1, sm: 1.5 },
              }}
            >
              {/* Title */}
              <Grid item xs={11} sm={11} md={11}>
                <DialogTitle
                  sx={{
                    textAlign: { xs: "center", sm: "left" },
                    fontSize: { xs: "18px", sm: "22px", md: "25px" },
                    fontWeight: "bold",
                    color: "#fff",
                    p: 0,
                  }}
                >
                  Claim Registration
                </DialogTitle>
              </Grid>

              <Grid
                item
                xs={1}
                sm={1}
                md={1}
                sx={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: { xs: "center", sm: "flex-start" },
                  mt: { xs: 1, sm: 0 },
                }}
              >
                <CancelOutlinedIcon
                  onClick={handleCloseClaim}
                  fontSize="large"
                  sx={{
                    color: "red",
                    cursor: "pointer",
                    "&:hover": { opacity: 0.8 },
                  }}
                />
              </Grid>

              {/* Close Icon - fixed position in header */}
            </Grid>
          </Headroom>

          {/* Scrollable Content */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              p: { xs: 1.5, sm: 2 },
              backgroundColor: "#fafafa",
            }}
          >
            <ClaimRegistration
              Namee={patientFullName}
              claimPracticeID={PatientINFO?.practiceId}
              claimId={SelectedClaimId}
              patientName={patientFullName}
              claimpatientId={PatientINFO?.id}
              patientId={PatientINFO?.id}
              CloseModal={handleCloseClaim}
              applyRefresh={HandleRefresh}
            />
          </Box>
        </Box>
      </Modal>
      <Modal
        open={OpenpriorAuth}
        onClose={handleCloseVOb}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 1,
          zIndex: 1802,
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 24,
            width: { xs: "95%", sm: "90%", md: "80%", lg: "70%" },
            maxHeight: "90vh",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Headroom>
            <Grid
              container
              alignItems="center"
              sx={{
                backgroundColor: "#356F60",
                position: "sticky",
                top: 0,
                zIndex: 10,
                px: { xs: 1.5, sm: 2 },
                py: { xs: 1, sm: 1.5 },
              }}
            >
              {/* Title */}
              <Grid item xs={11} sm={11} md={11}>
                <DialogTitle
                  sx={{
                    textAlign: { xs: "center", sm: "left" },
                    fontSize: { xs: "18px", sm: "22px", md: "25px" },
                    fontWeight: "bold",
                    color: "#fff",
                    p: 0,
                  }}
                >
                  Prior Auth & VOB
                </DialogTitle>
              </Grid>

              <Grid
                item
                xs={1}
                sm={1}
                md={1}
                sx={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: { xs: "center", sm: "flex-start" },
                  mt: { xs: 1, sm: 0 },
                }}
              >
                <CancelOutlinedIcon
                  onClick={handleCloseVOb}
                  fontSize="large"
                  sx={{
                    color: "red",
                    cursor: "pointer",
                    "&:hover": { opacity: 0.8 },
                  }}
                />
              </Grid>

              {/* Close Icon - fixed position in header */}
            </Grid>
          </Headroom>

          {/* Scrollable Content */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              p: { xs: 1.5, sm: 2 },
              backgroundColor: "#fafafa",
            }}
          >
            <Prior_auth
              columnID={selectedAuth?.id}
              PriorPracticeID={PatientINFO?.practiceId}
              columnIDcpt={selectedAuth?.id}
              Source={selectedAuth?.source}
              handleClose4={handleCloseVOb}
              patientNameee={patientFullName}
              AutpattientID1={patientId}
               updateHealthHistory={(id, authId) => {
                  // setValue("approved", true);
                  setColumnID(authId);
                  // setapproveid(authId)
                }}
            ></Prior_auth>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={NewVOB}
        onClose={HandleCloseNewVOB}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 1,
          zIndex: 1500,
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 24,
            width: { xs: "95%", sm: "90%", md: "80%", lg: "70%" },
            maxHeight: "90vh",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Headroom>
            <Grid
              container
              alignItems="center"
              sx={{
                backgroundColor: "#356F60",
                position: "sticky",
                top: 0,
                zIndex: 10,
                px: { xs: 1.5, sm: 2 },
                py: { xs: 1, sm: 1.5 },
              }}
            >
              {/* Title */}
              <Grid item xs={11} sm={11} md={11}>
                <DialogTitle
                  sx={{
                    textAlign: { xs: "center", sm: "left" },
                    fontSize: { xs: "18px", sm: "22px", md: "25px" },
                    fontWeight: "bold",
                    color: "#fff",
                    p: 0,
                  }}
                >
                  Prior Auth & VOB
                </DialogTitle>
              </Grid>

              <Grid
                item
                xs={1}
                sm={1}
                md={1}
                sx={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: { xs: "center", sm: "flex-start" },
                  mt: { xs: 1, sm: 0 },
                }}
              >
                <CancelOutlinedIcon
                  onClick={HandleCloseNewVOB}
                  fontSize="large"
                  sx={{
                    color: "red",
                    cursor: "pointer",
                    "&:hover": { opacity: 0.8 },
                  }}
                />
              </Grid>
            </Grid>
          </Headroom>

          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              p: { xs: 1.5, sm: 2 },
              backgroundColor: "#fafafa",
            }}
          >
            <AuthorizationRegistration
              callingFrom={"Patient"}
              columnID={0}
              setAuthId={setAuthId}
              AutpattientID={patientId}
              patientName={patientFullName}
              patientId={patientId}
              CloseModal={HandleCloseNewVOB}
              FormCall={"demographic"}
              setResetTab={setResetTab}
              ResetTab={ResetTab}
              Charge1={"E0486"}
            ></AuthorizationRegistration>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={NewInsurance}
        onClose={HandleCloseNewInsurance}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(4px)",
        }}
      >
        <Box
          sx={{
            width: { xs: "95%", sm: "85%", md: "70%" },
            maxHeight: "90vh",
            bgcolor: "#f9fbfa",
            borderRadius: "16px",
            boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              background: "linear-gradient(90deg, #356F60, #4CAF93)",
              color: "#fff",
              px: 3,
              py: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography fontSize="20px" fontWeight="bold">
              Patient Insurance
            </Typography>

            <CancelOutlinedIcon
              onClick={HandleCloseNewInsurance}
              sx={{ cursor: "pointer" }}
            />
          </Box>

          {/* Body */}
          <Box sx={{ p: 3, overflowY: "auto" }}>
            <Grid container spacing={2}>
              {/* Primary Insurance */}
              <Grid item xs={6}>
                <Typography fontWeight="bold" mb={1}>
                  Primary Insurance
                </Typography>

                <AsyncSelect
                  cacheOptions
                  loadOptions={loadInsuranceOptions}
                  defaultOptions={false}
                  onChange={(e) => {
                    setPriInsuranceId(e?.value);
                    setPatientInsuranceName(e?.label);
                    setPriPayerId(e?.payerId);
                  }}
                  placeholder="Search Primary Insurance..."
                />
              </Grid>
              <Grid item xs={6}>
                <Typography fontWeight="bold" mb={1}>
                  Primary Member ID
                </Typography>
                <TextField
                  fullWidth
                  value={priMemberId}
                  onChange={(e) => setPriMemberId(e.target.value)}
                  size="small"
                />
              </Grid>

              {/* Secondary Insurance */}
              <Grid item xs={6}>
                <Typography fontWeight="bold" mb={1}>
                  Secondary Insurance
                </Typography>
                <AsyncSelect
                  cacheOptions
                  loadOptions={loadInsuranceOptions}
                  defaultOptions={false}
                  onChange={(e) => {
                    setSecInsuranceId(e?.value);
                    setSecondarInsuranceName(e?.label);
                    setSecPayerId(e?.payerId);
                  }}
                  placeholder="Search Secondary Insurance..."
                />
              </Grid>

              <Grid item xs={6}>
                <Typography fontWeight="bold" mb={1}>
                  Secondary Member ID
                </Typography>
                <TextField
                  fullWidth
                  value={secMemberId}
                  onChange={(e) => setSecMemberId(e.target.value)}
                  size="small"
                />
              </Grid>
            </Grid>
          </Box>

          {/* Footer */}
          <Box
            sx={{
              p: 2,
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              borderTop: "1px solid #eee",
            }}
          >
            <Button variant="outlined" onClick={HandleCloseNewInsurance}>
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleSubmitInsurance}
              sx={{
                background: "linear-gradient(90deg, #356F60, #4CAF93)",
              }}
            >
              Save Insurance
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={NewAppointment}
        onClose={HandleCloseNewAppointment}
        sx={{ zIndex: 1802 }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid
            container
            xs={12}
            style={{
              background: "#377562",
              position: "sticky",
              marginBottom: "14px",
              padding: "8px",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(54, 118, 196, 0.5)",
              display: "flex",
            }}
          >
            <Grid item xs={11}>
              <Typography
                style={{
                  fontSize: "17px",
                  fontWeight: "bold",
                  marginLeft: "5px",
                  color: "#fff",
                }}
              >
                {" "}
                Create New Appointment{" "}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <CancelOutlinedIcon
                onClick={HandleCloseNewAppointment}
                fontSize="medium"
                color="red"
                style={{
                  color: "red",
                  cursor: "pointer",
                  float: "right",
                }}
              ></CancelOutlinedIcon>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            padding={2}
            sx={{
              height: "400px", // Set a fixed height
              overflowY: "auto", // Enable vertical scrolling
              overflowX: "hidden", // Hide horizontal scrolling if not needed
            }}
          >
            <Grid item xs={6}>
              <InputLabel>Patient</InputLabel>
              <TextField size="small" fullWidth value={patientFullName} />
            </Grid>
            <Grid item xs={6}>
              <InputLabel>Providers</InputLabel>

              <ReactSelect
                value={providerList.find(
                  (option) => option.value === providerId,
                )}
                onChange={(option) => {
                  setProviderId(option.value);
                  setProviderName(option.label); // Set provider name
                  setProviderError(false);
                }}
                options={providerList}
              />
              {providerError && (
                <Typography color="error">Please select Provider.</Typography>
              )}
            </Grid>

            <Grid item xs={6}>
              <InputLabel>Start Time</InputLabel>
              <TextField
                type="time"
                size="small"
                fullWidth
                value={sTime}
                onChange={(e) => setSTime(e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <InputLabel>End Time</InputLabel>
              <TextField
                type="time"
                size="small"
                fullWidth
                value={eTime}
                onChange={(e) => setETime(e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <InputLabel>Date</InputLabel>
              <TextField
                type="date"
                size="small"
                fullWidth
                value={appointmentDate}
                onChange={(e) => setAppointmentDate(e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <InputLabel>Duration</InputLabel>
              <TextField
                type="text"
                size="small"
                fullWidth
                value={duration}
                disabled
              />
            </Grid>

            <Grid item xs={6}>
              <InputLabel>Reason</InputLabel>
              <TextField
                type="text"
                size="small"
                fullWidth
                value={appointmentReason}
                onChange={(e) => setAppointmentReason(e.target.value)}
              />
            </Grid>
            <Grid item xs={6}></Grid>
            {appid > 0 && (
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                sx={{
                  borderRadius: "8px",
                  height: "40px",
                  fontWeight: 600,
                  textTransform: "none",
                  backgroundColor: "#34a853", // green
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  "&:hover": {
                    backgroundColor: "#2c8e46",
                  },
                }}
                onClick={handleSendReminder}
                disabled={submitting}
              >
                Send Reminder
              </Button>
            </Grid>
            )}
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                sx={{
                  borderRadius: "8px",
                  height: "40px",
                  fontWeight: 600,
                  textTransform: "none",
                  backgroundColor: "#2d89ef", // blue
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  "&:hover": {
                    backgroundColor: "#1f6fd1",
                  },
                }}
                onClick={handleSubmitAPp}
                disabled={submitting}
              >
                Save
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                variant="contained"
                fullWidth
                sx={{
                  borderRadius: "8px",
                  height: "40px",
                  fontWeight: 600,
                  textTransform: "none",
                  backgroundColor: "#f39c12", // orange
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  "&:hover": {
                    backgroundColor: "#d68910",
                  },
                }}
                onClick={HandleCloseNewAppointment}
                disabled={submitting}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      {/* Header */}
      <Paper
        elevation={0}
        sx={{
          p: 1,
          mb: 1,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          borderRadius: 2,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center">
            <Avatar
              sx={{
                width: 50,
                height: 50,
                mr: 2,
                bgcolor: "white",
                color: "#667eea",
              }}
            >
              {PatientINFO?.lastName?.toString().charAt(0)}
            </Avatar>
            <Box>
              <Typography variant="h5" fontWeight="bold" color={"#fff"}>
                {PatientINFO?.lastName} {PatientINFO?.firstName}
              </Typography>
              {/* <Box display="flex" gap={2} mt={0.5}>
                <Typography variant="caption">
                  Insurance: {insuranceList.length}
                </Typography>
                <Typography variant="caption">
                  Claims: {claimsList.length}
                </Typography>
                <Typography variant="caption">
                  Appointments: {appointmentsList.length}
                </Typography>
              </Box> */}
            </Box>
          </Box>

          <Tooltip title="Toggle Options">
            <IconButton
              onClick={() => setShowOptions(!showOptions)}
              sx={{ color: "white" }}
            >
              <SettingsIcon />
            </IconButton>
          </Tooltip>
        </Box>

        {/* Options Panel */}
        <Collapse in={showOptions}>
          <Box
            mt={2}
            pt={2}
            sx={{ borderTop: "1px solid rgba(255,255,255,0.3)" }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={1.5}
            >
              <Typography variant="subtitle2" fontWeight="bold">
                SELECT CARDS TO DISPLAY ({activeCards}/10)
              </Typography>

              <Box display="flex" gap={1}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleShowAll}
                  sx={{ color: "white", borderColor: "white" }}
                >
                  Show All
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleShowNone}
                  sx={{ color: "white", borderColor: "white" }}
                >
                  Hide All
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={savePreferences}
                  sx={{ bgcolor: "white", color: "#667eea" }}
                >
                  Save
                </Button>
              </Box>
            </Box>

            {/* Checkboxes */}
            <Grid container spacing={1}>
              {Object.entries(cardConfig).map(([key, config]) => (
                <Grid item xs={12} sm={6} md={3} key={key}>
                  <Box
                    onClick={() => handleCardToggle(key)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      p: 1,
                      borderRadius: 1,
                      cursor: "pointer",
                      bgcolor: cardVisibility[key]
                        ? "rgba(255,255,255,0.15)"
                        : "transparent",
                      "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
                    }}
                  >
                    <Checkbox
                      size="small"
                      checked={cardVisibility[key]}
                      sx={{ color: "white", mr: 1 }}
                    />
                    <Box sx={{ color: "white", mr: 1 }}>
                      {React.cloneElement(config.icon, { fontSize: "small" })}
                    </Box>
                    <Typography variant="body2" sx={{ color: "white" }}>
                      {config.title}
                    </Typography>
                    {cardVisibility[key] && (
                      <Box sx={{ ml: "auto" }}>
                        <VisibilityIcon sx={{ fontSize: 16, color: "white" }} />
                      </Box>
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Collapse>
      </Paper>

      {/* Alerts */}
      {cardVisibility.alerts && alerts.length > 0 && (
        <Grid container spacing={1} sx={{ mb: 1 }}>
          {alerts.map((alert, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Alert severity={alert.type} sx={{ borderRadius: 2 }}>
                {alert.text}
              </Alert>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Cards Grid */}
      <Grid container spacing={1}>
        {cardVisibility.contact && (
          <Grid item xs={12} md={cardConfig.contact.size}>
            <ContactCard />
          </Grid>
        )}

        {cardVisibility.medical && (
          <Grid item xs={12} md={cardConfig.medical.size}>
            <MedicalCard />
          </Grid>
        )}

        {cardVisibility.insurance && (
          <Grid item xs={12} md={cardConfig.insurance.size}>
            {/* <InsuranceCard handleOpenNewInsurance={handleOpenNewInsurance}/>
             */}
            <Card
              sx={{
                height: "100%",
                borderRadius: 2,
                border: "1px solid #e0e0e0",
              }}
            >
              <CardContent sx={{ p: 1 }}>
                <Box display="flex" alignItems="center" mb={2}>
                  <Box
                    sx={{ bgcolor: "#e8f5e9", p: 1, borderRadius: 1, mr: 1.5 }}
                  >
                    <CreditCardIcon sx={{ color: "#2e7d32", fontSize: 20 }} />
                  </Box>
                  <Typography variant="subtitle1" fontWeight="600">
                    Insurance
                  </Typography>
                  <Button
                    size="small"
                    // startIcon={<AddIcon />}
                    onClick={() => {
                      handleOpenNewInsurance();
                    }}
                    sx={{
                      ml: "auto", // 🔥 this pushes button to right
                      textTransform: "none",
                      fontWeight: 600,
                      borderRadius: 2,
                      // px: 2,
                      bgcolor: "#689f38",
                      boxShadow: "none",
                      "&:hover": {
                        bgcolor: "#689f38",
                        boxShadow: "none",
                      },
                    }}
                    variant="contained"
                  >
                    Add/Change
                  </Button>
                </Box>

                <Stack spacing={1}>
                  {primaryInsurance && (
                    <Box>
                      <Typography
                        variant="subtitle2"
                        color="primary"
                        fontWeight={600}
                        // mb={1}
                      >
                        Primary Insurance
                      </Typography>
                      <Typography variant="body2" fontWeight="500">
                        {primaryInsurance.planName || "N/A"}
                      </Typography>
                      <Box display="flex" justifyContent="space-between">
                        <Box>
                          <Typography variant="caption" color="textSecondary">
                            Member ID
                          </Typography>
                          <Typography variant="body2">
                            {primaryInsurance.memberId || "N/A"}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography variant="caption" color="textSecondary">
                            Payer ID
                          </Typography>
                          <Typography variant="body2">
                            {primaryInsurance.payerId || "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  )}

                  {secondaryInsurance && (
                    <>
                      <Divider />
                      <Box>
                        <Typography
                          variant="subtitle2"
                          color="secondary"
                          fontWeight={600}
                          mb={1}
                        >
                          Secondary Insurance
                        </Typography>
                        <Typography variant="body2" fontWeight="500">
                          {secondaryInsurance.planName || "N/A"}
                        </Typography>
                        <Box display="flex" justifyContent="space-between">
                          <Box>
                            <Typography variant="caption" color="textSecondary">
                              Member ID
                            </Typography>
                            <Typography variant="body2">
                              {secondaryInsurance.memberId || "N/A"}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography variant="caption" color="textSecondary">
                              Payer ID
                            </Typography>
                            <Typography variant="body2">
                              {secondaryInsurance.payerId || "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </>
                  )}

                  {!primaryInsurance && !secondaryInsurance && (
                    <Typography variant="caption" color="textSecondary">
                      No insurance information available
                    </Typography>
                  )}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        )}

        {cardVisibility.provider && (
          <Grid item xs={12} md={cardConfig.provider.size}>
            <ProviderCard />
          </Grid>
        )}
        {cardVisibility.ReferringPhysician && (
          <Grid item xs={12} md={cardConfig.ReferringPhysician.size}>
            {/* <ReferringPhysician /> */}
            <Card
              sx={{
                height: "100%",
                borderRadius: 2,
                border: "1px solid #e0e0e0",
              }}
            >
              <CardContent sx={{ p: 1 }}>
                {/* Header */}
                <Box display="flex" alignItems="center" mb={2} gap={1}>
                  {/* Icon */}
                  <Box sx={{ bgcolor: "#e3f2fd", p: 0.7, borderRadius: 1 }}>
                    <HospitalIcon sx={{ color: "#1976d2", fontSize: 18 }} />
                  </Box>

                  {/* Title */}
                  <Typography
                    variant="subtitle2"
                    fontWeight="600"
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "150px", // adjust as needed
                    }}
                  >
                    Referring Physician
                  </Typography>

                  {/* Button */}
                  <Button
                    size="small"
                    onClick={handleGoToPatientChart}
                    variant="contained"
                    sx={{
                      ml: "auto",
                      px: 1.2,
                      py: 0.4,
                      fontSize: "12px",
                      minWidth: "auto",
                      textTransform: "none",
                      borderRadius: 1.5,
                      bgcolor: "#1976d2",
                      boxShadow: "none",
                      "&:hover": {
                        bgcolor: "#1565c0",
                        boxShadow: "none",
                      },
                    }}
                  >
                    Add/Change
                  </Button>
                </Box>

                <Stack spacing={1}>
                  {/* PRIMARY */}
                  {primary && (
                    <Box>
                      <Typography
                        variant="subtitle2"
                        color="primary"
                        fontWeight={600}
                      >
                        Primary Referring Provider
                      </Typography>

                      <Typography variant="body2" fontWeight="500">
                        {`${primary.firstName || ""} ${primary.lastName || ""}`.trim()}
                      </Typography>

                      <Box display="flex" justifyContent="space-between">
                        <Box>
                          <Typography variant="caption" color="textSecondary">
                            NPI
                          </Typography>
                          <Typography variant="body2">
                            {primary.npi || "N/A"}
                          </Typography>
                        </Box>

                        <Box>
                          <Typography variant="caption" color="textSecondary">
                            Phone
                          </Typography>
                          <Typography variant="body2">
                            {primary.phone || "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  )}

                  {/* SECONDARY */}
                  {secondary && (
                    <>
                      <Divider />
                      <Box>
                        <Typography
                          variant="subtitle2"
                          color="secondary"
                          fontWeight={600}
                          mb={1}
                        >
                          Secondary Referring Provider
                        </Typography>

                        <Typography variant="body2" fontWeight="500">
                          {`${secondary.firstName || ""} ${secondary.lastName || ""}`.trim()}
                        </Typography>

                        <Box display="flex" justifyContent="space-between">
                          <Box>
                            <Typography variant="caption" color="textSecondary">
                              NPI
                            </Typography>
                            <Typography variant="body2">
                              {secondary.npi || "N/A"}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography variant="caption" color="textSecondary">
                              Phone
                            </Typography>
                            <Typography variant="body2">
                              {secondary.phone || "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </>
                  )}

                  {/* EMPTY STATE */}
                  {!primary && !secondary && (
                    <Typography variant="caption" color="textSecondary">
                      No referring physician information available
                    </Typography>
                  )}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        )}

        {cardVisibility.authorizations && (
          <Grid item xs={12} md={cardConfig.authorizations.size}>
            <Card
              sx={{
                height: "100%",
                borderRadius: 2,
                border: "1px solid #e0e0e0",
              }}
            >
              <CardContent sx={{ p: 1 }}>
                {/* Header */}
                <Box display="flex" alignItems="center" mb={1}>
                  <Box
                    sx={{ bgcolor: "#f1f8e9", p: 1, borderRadius: 1, mr: 1.5 }}
                  >
                    <CheckCircleIcon sx={{ color: "#689f38", fontSize: 20 }} />
                  </Box>
                  <Typography variant="subtitle1" fontWeight="600">
                    Recent Auth/VOBs
                  </Typography>
                  <Button
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={HanldeOpenNewVOB}
                    sx={{
                      ml: "auto", // 🔥 this pushes button to right
                      textTransform: "none",
                      fontWeight: 600,
                      borderRadius: 2,
                      px: 2,
                      bgcolor: "#689f38",
                      boxShadow: "none",
                      "&:hover": {
                        bgcolor: "#689f38",
                        boxShadow: "none",
                      },
                    }}
                    variant="contained"
                  >
                    Add
                  </Button>
                </Box>

                {/* Recent Authorizations */}
                <Stack spacing={0.75}>
                  {recentAuths.length > 0 ? (
                    recentAuths.map((auth, index) => (
                      <Box
                        key={index}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        px={0.75}
                        py={0.75}
                        sx={{
                          bgcolor: "#fafafa",
                          borderRadius: 1,
                          border: `1px solid ${auth.statusColor || "#e0e0e0"}`,
                        }}
                      >
                        {/* Left */}
                        <Box>
                          <Typography variant="body2" fontWeight={600}>
                            {auth.name}
                          </Typography>

                          <Typography variant="caption" color="textSecondary">
                            {auth.date} | CPT: {auth.cptCode || "N/A"}
                          </Typography>
                        </Box>

                        <Box display="flex" alignItems="center" gap={0.5}>
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() => {
                              setOpenpriorAuth(true);
                              setselectedAuth(auth);
                            }}
                            sx={{
                              minWidth: "auto",
                              px: 1,
                              py: 0,
                              fontSize: "0.65rem",
                              textTransform: "none",
                              borderRadius: 1,
                            }}
                          >
                            View
                          </Button>

                          <Chip
                            label={getStatusLabel(auth.statusColor)}
                            size="small"
                            // sx={getStatusChipStyle(auth.auth)}
                            sx={{
                              bgcolor: auth.statusColor,
                              color: "#fff",
                              fontWeight: 500,
                              height: "auto",
                              fontSize: "0.60rem",
                              maxWidth: 90,
                              "& .MuiChip-label": {
                                whiteSpace: "normal",
                                textAlign: "center",
                                lineHeight: 1.2,
                                padding: "2px 6px",
                              },
                            }}
                            noWrap
                          />
                        </Box>
                      </Box>
                    ))
                  ) : (
                    <Typography variant="caption" color="textSecondary">
                      No VOBs available
                    </Typography>
                  )}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        )}
        {cardVisibility.documents && (
          <Grid item xs={12} md={cardConfig.documents.size}>
            <Card
              sx={{
                height: "100%",
                borderRadius: 2,
                border: "1px solid #e0e0e0",
              }}
            >
              <CardContent sx={{ p: 1 }}>
                {/* Header */}
                <Box display="flex" alignItems="center" mb={1}>
                  <Box
                    sx={{ bgcolor: "#f3e5f5", p: 1, borderRadius: 1, mr: 1.5 }}
                  >
                    <FileCopyIcon sx={{ color: "#7b1fa2", fontSize: 20 }} />
                  </Box>

                  <Typography variant="subtitle1" fontWeight="600">
                    Recent Claims
                  </Typography>

                  <Button
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => {
                      setOpenClaimModal(true);
                      setSelectedClaimId(0);
                    }}
                    sx={{
                      ml: "auto", // 🔥 this pushes button to right
                      textTransform: "none",
                      fontWeight: 600,
                      borderRadius: 2,
                      px: 2,
                      bgcolor: "#7b1fa2",
                      boxShadow: "none",
                      "&:hover": {
                        bgcolor: "#6a1b9a",
                        boxShadow: "none",
                      },
                    }}
                    variant="contained"
                  >
                    Add
                  </Button>
                </Box>

                {/* Rows */}
                <Stack spacing={0.75}>
                  {recentClaims.length > 0 ? (
                    recentClaims.map((doc) => {
                      const status = getClaimStatus(doc.statusColor);

                      return (
                        <Box
                          key={doc.id}
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          p={0.75}
                          sx={{
                            bgcolor: "#fafafa",
                            borderRadius: 1,
                            border: `1px solid ${status.bg}`,
                          }}
                        >
                          {/* Left */}
                          <Box flex={1} minWidth={0}>
                            <Typography variant="body2" fontWeight={600}>
                              {doc.name}
                            </Typography>

                            <Box display="flex" gap={1}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                noWrap
                              >
                                {doc.date}
                              </Typography>

                              <Typography variant="caption" fontWeight={600}>
                                {doc.amount}
                              </Typography>
                            </Box>
                          </Box>

                          {/* Status */}

                          <Box display="flex" alignItems="center" gap={0.5}>
                            <Button
                              size="small"
                              variant="outlined"
                              onClick={() => {
                                setSelectedClaimId(doc.id);
                                setOpenClaimModal(true);
                              }}
                              sx={{
                                minWidth: "auto",
                                px: 1,
                                py: 0,
                                fontSize: "0.65rem",
                                textTransform: "none",
                                borderRadius: 1,
                              }}
                            >
                              View
                            </Button>

                            <Chip
                              label={status.label}
                              size="small"
                              sx={{
                                bgcolor: status.bg,
                                color: "#fff",
                                fontWeight: 500,
                                height: "auto",
                                fontSize: "0.60rem",
                                maxWidth: 90,
                                "& .MuiChip-label": {
                                  whiteSpace: "normal",
                                  textAlign: "center",
                                  lineHeight: 1.2,
                                  padding: "2px 6px",
                                },
                              }}
                              noWrap
                            />
                          </Box>
                        </Box>
                      );
                    })
                  ) : (
                    <Typography variant="caption" color="textSecondary">
                      No recent claims available
                    </Typography>
                  )}

                  {/* {recentClaims.length > 0 && (
          <Typography
            variant="caption"
            color="primary"
            align="center"
            sx={{ mt: 0.5 }}
          >
            {recentClaims.length} recent claims
          </Typography>
        )} */}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        )}
        {cardVisibility.appointments && (
          <Grid item xs={12} md={cardConfig.appointments.size}>
            <Card
              sx={{
                height: "100%",
                borderRadius: 2,
                border: "1px solid #e0e0e0",
              }}
            >
              <CardContent sx={{ p: 1 }}>
                <Box display="flex" alignItems="center" mb={2}>
                  <Box
                    sx={{ bgcolor: "#e3f2fd", p: 1, borderRadius: 1, mr: 1.5 }}
                  >
                    <CalendarIcon sx={{ color: "#1976d2", fontSize: 20 }} />
                  </Box>

                  <Typography variant="subtitle1" fontWeight="600">
                    Appointments
                  </Typography>

                  <Button
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={HanldeOpenNewAppointment}
                    sx={{
                      ml: "auto",
                      textTransform: "none",
                      fontWeight: 600,
                      borderRadius: 2,
                      px: 2,
                      bgcolor: "#1976d2",
                      boxShadow: "none",
                      "&:hover": {
                        bgcolor: "#1565c0",
                        boxShadow: "none",
                      },
                    }}
                    variant="contained"
                  >
                    Add
                  </Button>
                </Box>

                <Grid container spacing={1}>
                  {appointmentsList && appointmentsList.length > 0 ? (
                    <>
                      {/* Left Column (max 3 appointments) */}
                      <Grid item xs={6}>
                        {sortedAppointments
                          .slice(0, 3)
                          .map((appointment, index) => (
                            <Box
                              key={appointment.id || index}
                              onClick={() =>
                                handleOpenAppointment(appointment.id)
                              }
                              sx={{
                                bgcolor: "#f5f7fa",
                                borderLeft: "3px solid #90caf9",
                                p: 1,
                                mb: 0.8,
                                cursor: "pointer",
                                borderRadius: 1.2,
                                minHeight: 55,
                                transition: "0.2s ease",
                                "&:hover": {
                                  bgcolor: "#edf3f9",
                                  boxShadow: 1,
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "0.7rem",
                                  fontWeight: 600,
                                  color: "#1565c0",
                                }}
                              >
                                {formatDate(appointment.appointmentDate)}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "0.75rem",
                                  fontWeight: 500,
                                  lineHeight: 1.1,
                                }}
                              >
                                {formatTime(appointment.startTime)} •{" "}
                                {appointment.appointmentReason || "Appointment"}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "0.65rem",
                                  color: "text.secondary",
                                }}
                              >
                                {appointment.providerName || "Provider"} •{" "}
                                {appointment.duration || 0} mins
                              </Typography>
                            </Box>
                          ))}
                      </Grid>

                      {/* Right Column (next 2 appointments) */}
                      <Grid item xs={6}>
                        {sortedAppointments
                          .slice(3, 5)
                          .map((appointment, index) => (
                            <Box
                              key={appointment.id || index}
                              sx={{
                                bgcolor: "#f5f7fa",
                                borderLeft: "3px solid #90caf9",
                                p: 1,
                                mb: 0.8,
                                borderRadius: 1.2,
                                minHeight: 55,
                                transition: "0.2s ease",
                                "&:hover": {
                                  bgcolor: "#edf3f9",
                                  boxShadow: 1,
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "0.7rem",
                                  fontWeight: 600,
                                  color: "#1565c0",
                                }}
                              >
                                {formatDate(appointment.appointmentDate)}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "0.75rem",
                                  fontWeight: 500,
                                  lineHeight: 1.1,
                                }}
                              >
                                {formatTime(appointment.startTime)} •{" "}
                                {appointment.appointmentReason || "Appointment"}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "0.65rem",
                                  color: "text.secondary",
                                }}
                              >
                                {appointment.providerName || "Provider"} •{" "}
                                {appointment.duration || 0} mins
                              </Typography>
                            </Box>
                          ))}
                      </Grid>

                      {/* Full List Note */}
                      <Grid item xs={12}>
                        <Divider sx={{ my: 0.5 }} />
                        <Box
                          sx={{
                            bgcolor: "#fafafa",
                            mt: 0.5,
                            p: 0.8,
                            borderRadius: 1,
                          }}
                        >
                          <Typography
                            variant="caption"
                            fontStyle="italic"
                            color="text.secondary"
                            sx={{
                              textAlign: "center",
                              lineHeight: 1.1,
                              fontSize: "0.7rem",
                            }}
                          >
                            Please visit the Patient Appointment tab to see the
                            full list of appointments.
                          </Typography>
                        </Box>
                      </Grid>
                    </>
                  ) : (
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          bgcolor: "#f4f6f8",
                          p: 1,
                          borderRadius: 1.5,
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          sx={{ fontSize: "0.7rem", color: "text.secondary" }}
                        >
                          No upcoming appointments
                        </Typography>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        )}
        {cardVisibility.financial && (
          <Grid item xs={12} md={cardConfig.financial.size}>
            <FinancialCard />
          </Grid>
        )}
        {cardVisibility.Comments && (
          <Grid item xs={12} md={cardConfig.financial.size}>
            {/* <PatientCommentsCard /> */}
            <Card
              sx={{
                borderRadius: 4,
                border: "1px solid",
                borderColor: "error.light",
                background:
                  "linear-gradient(145deg, rgba(255,235,238,0.9), rgba(255,255,255,1))",
                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: "0 12px 32px rgba(0,0,0,0.12)",
                  transform: "translateY(-2px)",
                },
              }}
            >
              <CardContent sx={{ p: 2.5 }}>
                <Grid container spacing={2}>
                  {/* Header */}
                  <Grid
                    item
                    xs={12}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Box display="flex" alignItems="center" gap={1}>
                      <Box
                        sx={{
                          width: 32,
                          height: 32,
                          borderRadius: "50%",
                          bgcolor: "error.main",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Comment sx={{ color: "#fff", fontSize: 18 }} />
                      </Box>

                      <Typography
                        variant="subtitle1"
                        fontWeight={700}
                        letterSpacing={0.3}
                      >
                        Comments/Notes
                      </Typography>
                    </Box>

                    {/* Edit / Save Button */}
                    {isEditing ? (
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        onClick={handleSaveComments}
                      >
                        Save
                      </Button>
                    ) : (
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={handleEdit}
                      >
                        Edit
                      </Button>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      sx={{
                        position: "relative",
                        bgcolor: "#fff",
                        borderRadius: 3,
                        p: 2,
                        border: "1px dashed",
                        borderColor: "error.light",
                      }}
                    >
                      {/* Accent bar */}
                      <Box
                        sx={{
                          position: "absolute",
                          left: 0,
                          top: 0,
                          height: "100%",
                          width: 6,
                          borderRadius: "3px 0 0 3px",
                          bgcolor: "error.main",
                        }}
                      />

                      {isEditing ? (
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          variant="outlined"
                          value={commentText}
                          onChange={(e) => setCommentText(e.target.value)}
                          sx={{
                            pl: 1,
                            "& .MuiOutlinedInput-root": { border: "none" },
                          }}
                        />
                      ) : (
                        <Typography
                          variant="body2"
                          sx={{
                            pl: 2,
                            // color: "error.dark",
                            fontWeight: 500,
                            lineHeight: 1.6,
                            whiteSpace: "pre-wrap", // preserves \n line breaks
                            wordWrap: "break-word", // wraps long words
                          }}
                        >
                          {commentText ||
                            "No comments available for this patient."}
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default PatientSummary;
